import { makeStyles } from 'tss-react/mui';
import { useIsMobile } from '@client/hooks/dom.hooks';
import { getBasicEmbed } from '@sda/utils/url';
import type {
  BandcampResponse, SoundcloudResponse, SpotifyResponse, VimeoResponse, YoutubeResponse,
} from '@sda/utils/url/interfaces';

const useStyles = makeStyles(({ name: 'MediaEmbed' }))({
  spotifyPlayer: {
    height: 80,
  },
});

interface MediaEmbedProps extends BandcampResponse, SoundcloudResponse, SpotifyResponse, VimeoResponse, YoutubeResponse {
  readonly mediaType: 'audio' | 'video';
}

export const MediaEmbed: React.FC<MediaEmbedProps> = ({ mediaType, ...restProps }) => {
  const { classes } = useStyles();
  const isMobile = useIsMobile();

  if (mediaType === 'video' && (restProps.youtubeUri || restProps.vimeoUri)) {
    let uri = '';

    if (restProps.youtubeUri) {
      uri = restProps.youtubeUriCache?.embedUri;
    } else if (restProps.vimeoUri) {
      uri = restProps.vimeoUriCache?.embedUri;
    }

    if (!uri) {
      return null;
    }

    return (
      <iframe
        {...getBasicEmbed(uri, isMobile ? '190px' : '400px', '100%')}
        title="Video"
      />
    );
  }

  if (mediaType === 'audio' && (restProps.bandcampUri || restProps.soundcloudUri || restProps.spotifyUri)) {
    let uri = '';
    let isSpotify = false;

    if (restProps.bandcampUri) {
      uri = restProps.bandcampUriCache?.embedUri;
    } else if (restProps.soundcloudUri) {
      uri = restProps.soundcloudUriCache?.embedUri;
    } else if (restProps.spotifyUri) {
      isSpotify = true;
      uri = restProps.spotifyUriCache?.embedUri;
    }

    if (!uri) {
      return null;
    }

    return (
      <iframe
        {...getBasicEmbed(uri, '100%', '100%')}
        title="Audio"
        className={isSpotify ? classes.spotifyPlayer : ''}
      />
    );
  }

  return null;
};
